module.exports = __webpack_public_path__ + "img/78_37.47053cc2.png";